import { defineStore } from 'pinia';
import { ref } from 'vue';

export interface Alert {
    id: string; // Añade un ID único
    message: string;
    type: 'success' | 'error' | 'warning' | 'info';
    duration?: number; // Duración en milisegundos
    visible: boolean;
}

export const useAlertStore = defineStore('alertStore', () => {
    const alerts = ref<Alert[]>([]);

    const alertCounter = ref(0);

    const addAlert = (alert: Omit<Alert, 'id' | 'visible'>) => {
        const newAlert: Alert = {
            ...alert,
            id: (++alertCounter.value).toString(), // Usa un contador para IDs únicos
            visible: true
        };
        // console.log('newAlert', newAlert);
        alerts.value.push(newAlert);

        if (alert.duration !== 0) {
            // console.log('alert.duration', alert.duration);
            setTimeout(() => removeAlert(newAlert), alert.duration || 5000);
        }

        // console.log('alerts', alerts.value);
    };

    const removeAlert = (alert: Alert) => {
        alert.visible = false; // Cambia la visibilidad primero
        setTimeout(() => {
            alerts.value = alerts.value.filter((a) => a.id !== alert.id);
        }, 300); // Timeout para animación de cierre
    };

    // Estado para la alerta
    const showAlert = ref(false);
    const alertType = ref(''); // Tipo de alerta: success, error, info
    const alertMessage = ref(''); // Mensaje que viene de la API
    const alertIcon = ref(''); // icono dinámico basado en el tipo de alerta

    /**
     * Función para activar la alerta
     * @param {string} type Tipo de alerta: 'success', 'error', 'info'
     * @param {string} message Mensaje recibido desde la API
     */
    const triggerAlert = (type: string, message: string) => {
        alertType.value = type;
        alertMessage.value = message;

        alertIcon.value = type === 'success' ? 'mdi-check-circle' : type === 'error' ? 'mdi-alert-circle' : 'mdi-information';

        showAlert.value = true;

        setTimeout(() => {
            showAlert.value = false;
        }, 5000);
    };

    return {
        alerts,
        addAlert,
        removeAlert,
        triggerAlert,
        showAlert,
        alertType,
        alertMessage,
        alertIcon
    };
});
